var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "", header: _vm.header } },
        [
          _c(
            "b-card-group",
            [
              _c(
                "b-card-body",
                [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("admin.welcome_message_desc"))),
                  ]),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("admin.welcome_message"),
                        "label-size": "lg",
                        "label-class": "font-weight-bold pt-0 mb-2",
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { id: "customToolbar" } },
                        [
                          _c(
                            "c-switch",
                            _vm._b(
                              {
                                attrs: {
                                  id: "isWelcomeMessage",
                                  color: "primary",
                                  label: "",
                                },
                                model: {
                                  value: _vm.isWelcomeMessage,
                                  callback: function ($$v) {
                                    _vm.isWelcomeMessage = $$v
                                  },
                                  expression: "isWelcomeMessage",
                                },
                              },
                              "c-switch",
                              _vm.labelIcon,
                              false
                            )
                          ),
                          _vm._v(
                            _vm._s(_vm.$t("admin.welcome_message_enable")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _c("textarea", {
                        ref: "editor",
                        staticClass: "form-control",
                        attrs: { disabled: !_vm.isWelcomeMessage },
                        domProps: { value: _vm.welcomeMessage },
                        on: { input: _vm.updateCode },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-card-footer",
            [
              _c(
                "b-button",
                {
                  staticClass: "px-4",
                  attrs: {
                    disabled: !this.welcomeMessage && this.isWelcomeMessage,
                    variant: "outline-primary",
                  },
                  on: { click: _vm.saveChanges },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message.update")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _vm.isWelcomeMessage
                    ? _c("b-card", { staticClass: "bg-grey-900" }, [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [_c("h4", [_vm._v(_vm._s(_vm.$t("admin.preview")))])]
                        ),
                        _c("p", [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.sanitizedWelcomeMessage),
                            },
                          }),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }